// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo-module--container--41f313"};